import SearchableSelect from "../SearchableSelect";
import { fmtTL, fmtDate } from "../../lib/format";

const DRAFT_HEADERS = ["Tür", "Proje", "Dönem", "Belge Tarihi", "Tutar (KDV Hariç)"];

// cariye ait hakedişten gelen taslak faturalar: seç → düzenle
function VendorDrafts({ drafts, editing, isDraftEdit, loadDraft, onDraftToNew }) {
  return (
    <div className="mt-2 bg-amber-50 border border-amber-300 rounded-md p-3 space-y-2" data-testid="vendor-drafts">
      <div className="text-xs font-bold text-amber-900 uppercase tracking-wide">Bu cariye ait {drafts.length} taslak fatura (hakedişten geldi) — düzenlemek için seçin</div>
      <table className="w-full text-xs">
        <thead><tr className="text-[10px] uppercase tracking-wider text-slate-600">
          {DRAFT_HEADERS.map((h, i) => <th key={h} className={`${i === 4 ? "text-right" : "text-left"} px-2 py-1`}>{h}</th>)}<th></th>
        </tr></thead>
        <tbody>
          {drafts.map((d) => (
            <tr key={d.id} className={`border-t border-amber-200 ${editing === d.id ? "bg-amber-100" : ""}`} data-testid={`vendor-draft-${d.id}`}>
              <td className="px-2 py-1.5">{d.direction === "income" ? "Gelir" : "Gider"}</td>
              <td className="px-2 py-1.5 font-medium">{d.project_name}</td>
              <td className="px-2 py-1.5">{d.claim?.period || "—"}</td>
              <td className="px-2 py-1.5">{fmtDate(d.invoice_date)}</td>
              <td className="px-2 py-1.5 text-right font-mono">{fmtTL(d.net_amount ?? d.total_amount)}</td>
              <td className="px-2 py-1.5 text-right">
                <button type="button" onClick={() => loadDraft(d)} data-testid={`vendor-draft-edit-${d.id}`}
                  className="px-2.5 py-1 rounded-md bg-amber-600 text-white text-[11px] font-bold hover:bg-amber-700">{editing === d.id ? "Düzenleniyor" : "Düzenle"}</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {isDraftEdit && <button type="button" onClick={onDraftToNew} data-testid="vendor-draft-new" className="text-[11px] text-amber-900 underline">Taslak yerine yeni fatura gir</button>}
    </div>
  );
}

// 1. Adım — Firma (Cari) seçimi + "Yeni Cari Aç" + cariye ait taslaklar
export default function VendorStep({ form, editing, isDraftEdit, cariOptions, refreshLists, onVendor, onNewCari, vendorDrafts, loadDraft, onDraftToNew }) {
  return (
    <div className={`rounded-lg border-2 p-4 space-y-2 transition-colors ${form.vendor ? "border-emerald-300 bg-emerald-50/40" : "border-amber-400 bg-amber-50/60"}`} data-testid="invoice-cari-step">
      <label className="block text-sm font-bold text-slate-900 uppercase tracking-wide">1. Adım — Firma (Cari) Seçin</label>
      <div className="[&_input]:py-3 [&_input]:text-base [&_input]:font-semibold">
        <SearchableSelect testid="invoice-field-vendor" onOpen={refreshLists} value={form.vendor} onChange={onVendor}
          placeholder="Cari adı yazarak arayın…" options={cariOptions}
          footer={{ label: "Yeni Cari Aç", testid: "invoice-cari-new", onClick: onNewCari }} />
      </div>
      {!form.vendor && <div className="text-xs text-amber-800 font-medium" data-testid="cari-first-hint">Önce firma (cari) seçin — listede yoksa "Yeni Cari Aç" ile ekleyebilirsiniz.</div>}
      {form.vendor && vendorDrafts.length > 0 && <VendorDrafts drafts={vendorDrafts} editing={editing} isDraftEdit={isDraftEdit} loadDraft={loadDraft} onDraftToNew={onDraftToNew} />}
    </div>
  );
}
